export function NullHandler( data: any ) {
}

export interface CxPromise<T> extends Promise<T> {
	cancel: () => boolean;
}

type PromiseStatus = "init" | "running" | "cancelled" | "completed" | "rejected";

export function CancelablePromise<T>( org: Promise<T> ): CxPromise<T> {
	let status: PromiseStatus = "init";
	const promise: Partial<CxPromise<T>> = new Promise( ( resolve, reject ) => {
		org.then( result => {
			if ( status !== "cancelled" ) {
				status = "completed";
				resolve( result );
			}
		} ).catch( reason => {
			status = "rejected";
			reject( reason );
		} );
	} );
	promise.cancel = () => {
		if ( status === "completed" || status === "rejected" ) {
			return false;
		}
		status = "cancelled";
		return true;
	};
	status = "running";
	return promise as CxPromise<T>;
}
